module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"mobile":{"description":"모바일 화면 디자인, 개발 시 적용합니다.","pagination_mobile_basic":{"detail1":"기본 페이지네이션입니다.","detail2":"모든 요소의 크기, 간격, 색상은 변경 불가합니다."}},"pc":{"description":"PC 화면 디자인, 개발 시 적용합니다."}}}')
  delete Component.options._Ctor
}
